import { useTranslation } from "react-i18next";
import { IconMovie, IconPlus } from "@tabler/icons-react";

import { Text, Button } from "@fragments";
import AICircle from "@components/AICircle";

import "./styles.scss";

/**
 * The "no video yet" card the Player floats over its stage for community
 * owners and creators (`placeholder` prop). It reads as part of the player's
 * chrome — the same translucent glass and fixed white ink as the control
 * pills — and offers the two things a creator does next: upload the video,
 * or get a script to record it.
 *
 * @param {() => void} onAddVideo         opens the content editor on this lesson
 * @param {() => void} onGenerateScript   opens the script generator
 */
export default function EmptyStage({ onAddVideo, onGenerateScript }) {
    const { t } = useTranslation("content");

    return (
        <div className="empty-stage" role="group" aria-label={t("emptyStage.title")}>
            <div className="empty-stage__icon" aria-hidden="true">
                <IconMovie size={22} stroke={1.5} />
            </div>

            <div className="empty-stage__copy">
                <Text.h5 weight={500}>{t("emptyStage.title")}</Text.h5>
                <Text.span className="empty-stage__subtitle">{t("emptyStage.subtitle")}</Text.span>
            </div>

            <div className="empty-stage__actions">
                <Button color="white" startIcon={<IconPlus />} onClick={onAddVideo} preventLoading>
                    {t("emptyStage.addVideo")}
                </Button>
                <Button color="overlay" startIcon={<AICircle size={20} />} onClick={onGenerateScript} preventLoading className="empty-stage__ai">
                    {t("emptyStage.generateScript")}
                </Button>
            </div>
        </div>
    );
}
